var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-popup-sub-text-sub-heading"},[_c('text-content',{attrs:{"size":'sm3',"weight":'extra-bold',"lineHeight":_vm.lineHeight,"decoration":_vm.decoration}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }